module.exports = __webpack_public_path__ + "static/media/8fit-three.67f885cd.svg";